import { motion, useReducedMotion } from "motion/react";

const DOT_SPACING = 24;
const DOT_COLUMNS = 86;
const DOT_ROWS = 50;

const dotColumns = Array.from({ length: DOT_COLUMNS }, (_, columnIndex) => ({
  id: `column-${columnIndex}`,
  x: columnIndex * DOT_SPACING - 56,
  delay: columnIndex * 0.055,
}));

const dotRows = Array.from({ length: DOT_ROWS }, (_, rowIndex) => ({
  id: `row-${rowIndex}`,
  y: rowIndex * DOT_SPACING - 28,
}));

export function AuthAnimatedBackground() {
  const reduceMotion = useReducedMotion();

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden bg-muted"
    >
      <svg
        className="absolute inset-0 h-full w-full opacity-[0.3]"
        viewBox="0 0 1920 1080"
        preserveAspectRatio="xMidYMid slice"
      >
        {dotColumns.map((column) => (
          <motion.g
            key={column.id}
            animate={
              reduceMotion
                ? undefined
                : {
                    x: [0, 2, -1, 0],
                    y: [0, -6, 4, 0],
                  }
            }
            transition={{
              duration: 6.4,
              repeat: Infinity,
              ease: "easeInOut",
              delay: column.delay,
            }}
          >
            {dotRows.map((row) => (
              <circle
                key={`${column.id}-${row.id}`}
                cx={column.x}
                cy={row.y}
                r="1"
                fill="#a8a8a8"
              />
            ))}
          </motion.g>
        ))}
      </svg>
    </div>
  );
}
